import Provider from "~/providers/new/provider";
import AdvancedFilter from "../models/advancedFilter";
import {Constructor} from "../../../global/constructor";
import {Hash} from "~/interfaces/hashInterfaces";

export default class AdvancedFilterProvider extends Provider<AdvancedFilter> {
  constructor(protected modelType: Constructor<AdvancedFilter> = AdvancedFilter,
              public modelRoot: string = 'advanced_filter',
              public collectionRoot: string = 'advanced_filters',
              protected endPointBase: string = collectionRoot) {
    super(modelType, modelRoot, collectionRoot, endPointBase);
  }
}